import qs from 'query-string'

import { ROUTE_PATH } from './paths'
import { matchI18nPath } from 'features/i18n/router'

export const setRedirectUrl = (url: string) => {
  try {
    const parsedUrl = new URL(url, window.location.href)
    parsedUrl.search = qs.stringify({
      ...qs.parse(parsedUrl.search),
      redirect: encodeURIComponent(
        `${window.location.pathname}${window.location.search}`
      ),
    })
    const withRedirectUrl = `${parsedUrl.pathname}${parsedUrl.search}`

    return withRedirectUrl
  } catch (e) {
    return url
  }
}

export const setLoginRedirectUrl = (url: string) => {
  const isFromLoginPage = Boolean(
    matchI18nPath(ROUTE_PATH.LOGIN, { startsWith: true })
  )

  try {
    const parsedUrl = new URL(url, window.location.href)
    if (isFromLoginPage) {
      parsedUrl.search = qs.stringify({
        ...qs.parse(parsedUrl.search),
        redirect: qs.parse(window.location.search)?.redirect || '',
      })
    } else {
      parsedUrl.search = qs.stringify({
        ...qs.parse(parsedUrl.search),
        redirect: encodeURIComponent(
          window.location.pathname.replace(ROUTE_PATH.LOGIN, '')
        ),
      })
    }

    const withRedirectUrl = `${parsedUrl.pathname}${parsedUrl.search}`

    return withRedirectUrl
  } catch (e) {
    return url
  }
}

export const getRedirectUrl = (url: string) => {
  try {
    const parsedUrl = new URL(url, window.location.href)
    const { redirect } = qs.parse(parsedUrl.search)
    return typeof redirect !== 'undefined'
      ? decodeURIComponent(redirect.toString())
      : undefined
  } catch (e) {
    return undefined
  }
}

export const withRedirectUrl = (url: string) => {
  try {
    const parsedUrl = new URL(url, window.location.href)
    parsedUrl.search = qs.stringify({
      ...qs.parse(parsedUrl.search),
      redirect: getRedirectUrl(window.location.href),
    })
    const withRedirectUrl = `${parsedUrl.pathname}${parsedUrl.search}`

    return withRedirectUrl
  } catch (e) {
    return url
  }
}

export const redirectToPreviousPage = () => {
  // default history stack is 2 items, tested on Chrome, Safari and Firefox
  // https://stackoverflow.com/questions/3588315/how-to-check-if-the-user-can-go-back-in-browser-history-or-not
  if (window.history.length > 2) {
    window.history.back()
  } else {
    window.location.href = ROUTE_PATH.HOME
  }
}

export const isBackNavigationToTimeline = () => {
  // check if the current navigation was a back navigation
  // this is used internally by the useTimeline hook

  if (sessionStorage.getItem('timeline-back-navigation') === 'true') {
    return true
  }

  return false
}

export const clearBackNavigationFlag = () => {
  // also for useTimeline
  sessionStorage.removeItem('timeline-back-navigation')
}
